module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.reviewCount !== undefined && _vm.reviewCount !== 0) ? _c('div', {
    staticClass: "review__rating-box box__rating-box"
  }, [(_vm.reviewCount !== 0 && _vm.reviewCount !== undefined) ? _c('div', {
    staticClass: "review__rating-stars"
  }, [_c('stars', {
    attrs: {
      "value": _vm.stars,
      "disabled": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "review_date box__review-date"
  }, [_vm._v(_vm._s(_vm._f("reviewCase")(_vm.reviewCount)))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2eae826"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stars/Rating.vue
// module id = 645
// module chunks = 0